import { PICTREE } from "../../constants";
import {
  combineBudgetSourceRows,
  composeBudgetSummary,
  mergeBudgetSummary,
} from "./budgetHelpers";

const initialHomePhotoShoot = {
  countDenchu: 'loading',
  countUniqueUser: 'loading',
  countNewUser: 'loading',
  countAsset: 'loading',
  countDupeDenchu: 'loading',
  countReviewOk: 'loading',
  progressDenchu: { taken: 0, max: 0, maxByasset: 0 },
  timings: {}, // {key: ms}
  errors:  {}, // {key: message}
};

const initialState = {
  homeDataUser: {},
  homeDataCheckIn: {},
  homeDataPhotoShoot: initialHomePhotoShoot,
  dataPhotoShootByAsset: [],
  photoShootTrendByAsset: [],
  checkInTrend: [],
  // dataCheckInMap: [],
  // dataCheckInTable: [],
  // pictreeView: null,
  photoShootTrend: [],
  // photoShootDenchuKaisuTrend: [],
  // chartSize: "day",
  // mapType: "taken",
  photoShootMapData: {taken: [], untaken: []},
  // missionData: [],
  // missionSummaryData: {},
  // missionRankingData: [],
  // rewardCoinSummaryData: {},
  // rewardCoinData: [],
  // rewardCoinRankingData: [],
  budgetSummary: null,
  budgetBaseSummary: null,
  budgetRemainingTrend: null,
  budgetBySourceRows: [],
  budgetByBoostRows: [],
  budgetBaseSourceRows: [],
  budgetBoostSourceRows: [],
  budgetSourceLoading: false,
  budgetBoostSourceLoading: false,
  budgetBoostLoading: false,
  // dateRangePicTree: [null, null],
  // periodType: "season",
  selectedSeason: [],
  seasonData: [],
  byAreaDataSummary: [],
  byAreaDataTable: [],
  // missionData: [],
  // selectedMission: "blank",
  groupSummaryData: {},
};

export default function pictreeHokudenReducer(state = initialState, action) {
  switch (action.type) {
    case PICTREE.SET_HOME_USER:
      return {
        ...state,
        homeDataUser: action.payload,
      };
    case PICTREE.SET_HOME_CHECKIN_HOKUDEN:
      return {
        ...state,
        homeDataCheckIn: action.payload,
      };
    case PICTREE.SET_HOME_PHOTOSHOOT_HOKUDEN:
      return {
        ...state,
        homeDataPhotoShoot: action.payload,
      };
    case PICTREE.SET_PHOTOSHOOT_TREND_HOKUDEN:
      return {
        ...state,
        photoShootTrend: action.payload,
      };
    case PICTREE.PATCH_HOME_PICTREE_PHOTO_SHOOT_HOKUDEN:
      return {
        ...state,
        homeDataPhotoShoot: {
          ...state.homeDataPhotoShoot,
          ...action.payload,
          progressDenchu: {
            ...(state.homeDataPhotoShoot.progressDenchu || {}),
            ...(action.payload.progressDenchu || {}),
          },
          timings: {
            ...(state.homeDataPhotoShoot.timings || {}),
            ...(action.payload.timings || {}),
          },
          errors: {
            ...(state.homeDataPhotoShoot.errors || {}),
            ...(action.payload.errors || {}),
          },
        },
      };
    case PICTREE.SET_PHOTOSHOOT_BY_ASSET_HOKUDEN:
      return {
        ...state,
        dataPhotoShootByAsset: action.payload,
      };
    case PICTREE.SET_PHOTOSHOOT_TREND_BY_ASSET_HOKUDEN:
      return {
        ...state,
        photoShootTrendByAsset: action.payload,
      };
    case PICTREE.SET_PHOTOSHOOT_DETAILS:
      return {
        ...state,
        dataPhotoShootDetails: action.payload,
      };
    case PICTREE.SET_CHECKIN_TREND_HOKUDEN:
      return {
        ...state,
        checkInTrend: action.payload,
      };
    case PICTREE.SET_CHECKIN_MAP:
      return {
        ...state,
        dataCheckInMap: action.payload,
      };
    case PICTREE.SET_CHECKIN_TABLE:
      return {
        ...state,
        dataCheckInTable: action.payload,
      };
    case PICTREE.SET_PICTREE_VIEW:
      return {
        ...state,
        pictreeView: action.payload,
      };
    case PICTREE.SET_PHOTOSHOOT_TREND:
      return {
        ...state,
        photoShootTrend: action.payload,
      };
    case PICTREE.SET_PHOTOSHOOT_DENCHU_KAISU_TREND:
      return {
        ...state,
        photoShootDenchuKaisuTrend: action.payload,
      };
    case PICTREE.SET_CHART_SIZE:
      return {
        ...state,
        chartSize: action.payload,
      };
    case PICTREE.SET_MAP_TYPE:
      return {
        ...state,
        mapType: action.payload,
      };
    case PICTREE.SET_PHOTOSHOOT_MAP_DATA_HOKUDEN:
      return {
        ...state,
        photoShootMapData: action.payload,
      };
    case PICTREE.SET_BY_AREA_DATA_SUMMARY_HOKUDEN:
      return {
        ...state,
        byAreaDataSummary: action.payload
      };
    case PICTREE.SET_BY_AREA_DATA_TABLE_HOKUDEN:
      return {
        ...state,
        byAreaDataTable: action.payload
      };
    case PICTREE.SET_MISSION_DATA:
      return {
          ...state,
          missionData: action.payload
      };
    case PICTREE.SET_MISSION_SUMMARY_DATA:
      return {
          ...state,
          missionSummaryData: action.payload
      };
    case PICTREE.SET_MISSION_RANKING_DATA:
      return {
          ...state,
          missionRankingData: action.payload
      };
    case PICTREE.SET_REWARD_COIN_SUMMARY_DATA:
      return {
          ...state,
          rewardCoinSummaryData: action.payload
      };
    case PICTREE.SET_REWARD_COIN_DATA:
      return {
          ...state,
          rewardCoinData: action.payload
      };
    case PICTREE.SET_REWARD_COIN_RANKING_DATA:
      return {
          ...state,
          rewardCoinRankingData: action.payload
      };
    case PICTREE.SET_BUDGET_SUMMARY_DATA_HOKUDEN: {
      const baseSourceRowsHokuden = action.payload?.bySourceRows || [];
      const baseSummaryHokuden = action.payload ? mergeBudgetSummary(null, action.payload) : null;
      return {
          ...state,
          budgetBaseSummary: baseSummaryHokuden,
          budgetSummary: composeBudgetSummary(baseSummaryHokuden, state.budgetBoostSourceRows, state.budgetSummary?.boostEventCount),
          budgetBaseSourceRows: baseSourceRowsHokuden,
          budgetBySourceRows: combineBudgetSourceRows(baseSourceRowsHokuden, state.budgetBoostSourceRows),
      };
    }
    case PICTREE.SET_BUDGET_REMAIN_TREND_DATA_HOKUDEN:
      return {
          ...state,
          budgetRemainingTrend: action.payload || null,
      };
    case PICTREE.SET_BUDGET_BOOST_DATA_HOKUDEN:
      return {
        ...state,
        budgetByBoostRows: action.payload || [],
      };
    case PICTREE.SET_BUDGET_BOOST_SOURCE_DATA_HOKUDEN: {
      const boostSourceRowsHokuden = action.payload?.rows || [];
      const boostEventCount = action.payload?.boostEventCount;
      return {
          ...state,
          budgetBoostSourceRows: boostSourceRowsHokuden,
          budgetSummary: composeBudgetSummary(state.budgetBaseSummary, boostSourceRowsHokuden, boostEventCount),
          budgetBySourceRows: combineBudgetSourceRows(state.budgetBaseSourceRows, boostSourceRowsHokuden),
      };
    }
    case PICTREE.SET_BUDGET_SOURCE_LOADING_HOKUDEN:
      return {
          ...state,
          budgetSourceLoading: Boolean(action.payload),
      };
    case PICTREE.SET_BUDGET_BOOST_SOURCE_LOADING_HOKUDEN:
      return {
          ...state,
          budgetBoostSourceLoading: Boolean(action.payload),
      };
    case PICTREE.SET_BUDGET_BOOST_LOADING_HOKUDEN:
      return {
          ...state,
          budgetBoostLoading: Boolean(action.payload),
      };
    case PICTREE.SET_PERIOD_TYPE:
      return {
          ...state,
          periodType: action.payload
      };
    case PICTREE.SET_SELECTED_SEASON_HOKUDEN:
      return {
          ...state,
          selectedSeason: action.payload || []
      };
    case PICTREE.SET_SEASON_DATA_HOKUDEN:
      return {
          ...state,
          seasonData: action.payload
      };
    case PICTREE.SET_MISSION_DATA:
      return {
          ...state,
          missionData: action.payload
      };
    case PICTREE.SET_SELECTED_MISSION:
      return {
          ...state,
          selectedMission: action.payload
      };
    case PICTREE.SET_GROUP_SUMMARY_HOKUDEN:
      return {
        ...state,
        groupSummaryData: action.payload
      };
    default:
      return state;
  }
}
